import { isMobile } from "src/utils/isMobile";

export function ItemDescription({
  label,
  children,
  className,
  childrenOnNextLine,
}: {
  label: string;
  children: React.ReactNode;
  className?: string;
  childrenOnNextLine?: boolean;
}) {
  return (
    <div
      className={`border-b-2 border-Grey2 w-full min-h-10 flex flex-row ${className}`}
    >
      <div
        className={`w-2/6 h-full flex ml-${
          isMobile() ? "2" : "[20%]"
        } items-center`}
      >
        {label}
      </div>
      <div
        className={`${"w-4/6"} h-full border-left-2 ${
          isMobile() ? "ml-4" : ""
        } border-Grey2 flex items-center mt-1 min-w-0`}
      >
        {!childrenOnNextLine ? children : null}
      </div>
      {!childrenOnNextLine ? null : children}
    </div>
  );
}
